/**
 * @module Experience/Billing-Landing
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
// Core Dependencies
import { Injectable, EventEmitter } from '@angular/core';
import {
  CartNotEmptyServiceEmitterInterface,
  CartNotEmptyRouteObject,
} from '@support/shared/widgets/interfaces/cart-not-empty-modal.interface';

@Injectable()
export class CartNotEmptyModalService {
  public emitter: EventEmitter<CartNotEmptyServiceEmitterInterface>;
  constructor() {
    this.emitter = new EventEmitter();
  }

  public openModal(route: CartNotEmptyRouteObject): void {
    this.emitter.emit({
      method: 'open',
      arg: route,
    });
  }

  public closeModal(): void {
    this.emitter.emit({
      method: 'close',
      arg2: false,
    });
  }
}
